<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable no-undef -->
<!-- eslint-disable vue/multi-word-component-names -->

<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-app>
    <!-- Top Navigation Bar -->
    <v-app-bar :color="colors.primaryDark" dark elevation="4" height="60">
      <div class="d-flex align-center">
        <v-icon size="40" class="ml-7 mr-2 pulse">fas fa-building</v-icon>
        <span class="text-h6 font-weight-bold gradient-text">
          SICON PAINEL DE CONTROLE I.A
        </span>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center" style="gap: 24px">
        <!-- User Profile -->
        <div class="d-flex align-center mr-12 user-profile" style="gap: 7px">
          <v-avatar size="40" :color="colors.primaryLight" class="profile-avatar">
            <v-icon color="white" size="20">fas fa-user</v-icon>
          </v-avatar>
          <div class="d-flex flex-column">
            <span class="font-weight-bold text-body-2">
              {{ userDetails?.name || 'Carregando...' }}
            </span>
            <span class="text-caption opacity-75">
              {{ userDetails?.department?.name || 'Online' }}
            </span>
          </div>
        </div>
      </div>
    </v-app-bar>

    <!-- Sidebar Navigation -->
    <v-navigation-drawer
      v-model="drawer"
      :color="colors.primaryDark"
      dark
      permanent
      width="250"
      class="custom-drawer"
    >
      <!-- User Profile in Sidebar -->
      <div class="pa-4 sidebar-profile" style="border-bottom: 1px solid #1a4b7a">
        <div class="d-flex align-center" style="gap: 12px">
          <v-avatar size="45" :color="colors.primaryLight" class="profile-avatar">
            <v-icon color="white" size="22">fas fa-user</v-icon>
          </v-avatar>
          <div>
            <div>
              <div>
                <div class="font-weight-bold text-body-2 lowercase">
                  {{ userDetails?.name || 'Carregando...' }}
                </div>
              </div>
            </div>
            <div class="text-caption opacity-75">
              {{ userDetails?.department?.name || 'Sistema Online' }}
            </div>
          </div>
        </div>
      </div>

      <!-- Navigation Menu -->
      <v-list nav class="pa-0 text-start">
        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          :value="item.value"
          :active="item.active"
          rounded="xl"
          class="mb-2 menu-item"
          :class="item.active ? 'active-item' : ''"
          lines="one"
          density="comfortable"
          @click="router.push(item.route)"
        >
          <template #prepend>
            <v-icon size="22" class="mr-2">{{ item.icon }}</v-icon>
          </template>

          <template #title>
            <span class="item-title">{{ item.title }}</span>
          </template>

          <template #append v-if="item.badge">
            <v-chip size="small" :color="item.badgeColor" class="pulse-badge">
              {{ item.badge }}
            </v-chip>
          </template>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="pa-3" style="border-top: 1px solid #1a4b7a">
          <v-btn
            block
            variant="outlined"
            prepend-icon="fas fa-sign-out-alt"
            class="logout-btn"
            @click="logout"
          >
            Sair
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- Main Content - Kanban Board -->
    <v-main class="bg-grey-lighten-5">
  <!-- Loading state enquanto verifica permissões -->
      <div v-if="checkingAccess" class="d-flex justify-center align-center" style="height: 100vh;">
        <v-progress-circular 
          indeterminate 
          color="primary"
          size="64"
        />
        <span class="ml-4">Verificando permissões...</span>
      </div>

      <!-- Conteúdo principal só aparece se tem acesso -->
      <v-container v-else-if="hasAccess" fluid class="pa-4">
        <!-- Loading Overlay -->
        <v-overlay
          v-model="loading"
          class="align-center justify-center"
          persistent
        >
          <v-progress-circular
            color="primary"
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>

        <!-- Page Header -->
        <div class="d-flex justify-space-between align-center mb-6">
          <div class="d-flex" style="gap: 16px">
            <v-btn
              :color="colors.primaryLight"
              prepend-icon="fas fa-tasks"
              elevation="0"
            >
              <b style="color: #ffff">Gerenciador de Tarefas</b>
            </v-btn>
          </div>
          <v-btn
            :color="colors.primaryGreen"
            prepend-icon="fas fa-plus"
            elevation="0"
            @click="dialogNovaTarefa = true"
          >
            <b style="color: #fff">Nova Tarefa</b>
          </v-btn>
        </div>

        <!-- Estatísticas das Tarefas -->
        <v-row class="mb-6">
          <v-col cols="12" sm="6" md="3">
            <v-card
              elevation="2"
              class="text-center pa-4"
              :color="colors.primaryLight"
            >
              <v-icon size="40" color="white" class="mb-2">fas fa-list</v-icon>
              <div class="text-h4 font-weight-bold text-white">
                {{ tarefas.length }}
              </div>
              <div class="text-subtitle-1 text-white">Total de Tarefas</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-card elevation="2" class="text-center pa-4" color="success">
              <v-icon size="40" color="white" class="mb-2">fas fa-check-circle</v-icon>
              <div class="text-h4 font-weight-bold text-white">
                {{ tarefasConcluidas.length }}
              </div>
              <div class="text-subtitle-1 text-white">Concluídas</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-card elevation="2" class="text-center pa-4" color="warning">
              <v-icon size="40" color="white" class="mb-2">fas fa-clock</v-icon>
              <div class="text-h4 font-weight-bold text-white">
                {{ tarefasPendentes.length }}
              </div>
              <div class="text-subtitle-1 text-white">Pendentes</div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-card elevation="2" class="text-center pa-4" color="error">
              <v-icon size="40" color="white" class="mb-2">fas fa-exclamation-triangle</v-icon>
              <div class="text-h4 font-weight-bold text-white">
                {{ tarefasAtrasadas.length }}
              </div>
              <div class="text-subtitle-1 text-white">Atrasadas</div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Filtros -->
        <v-row class="mb-4">
          <v-col cols="12" md="6">
            <v-text-field
              v-model="filtroTitulo"
              placeholder="Buscar tarefa..."
              prepend-inner-icon="fas fa-search"
              variant="outlined"
              density="compact"
              hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="filtroPrioridade"
              :items="prioridadeOptions"
              placeholder="Filtrar por prioridade"
              variant="outlined"
              density="compact"
              hide-details
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-btn
              :color="colors.primaryLight"
              variant="outlined"
              @click="limparFiltros"
              block
            >
              Limpar Filtros
            </v-btn>
          </v-col>
        </v-row>

        <!-- Kanban Board -->
        <div class="kanban-board">
          <div
            v-for="coluna in colunas"
            :key="coluna.id"
            class="kanban-column"
            :class="{ 'drag-over': dragOverColumn === coluna.id }"
          >
            <!-- Header da Coluna -->
            <div class="column-header" :style="{ backgroundColor: coluna.cor }">
              <div class="d-flex align-center">
                <v-icon color="white" size="20" class="mr-2">{{ coluna.icone }}</v-icon>
                <span class="text-subtitle-1 font-weight-bold text-white">{{ coluna.titulo }}</span>
              </div>
              <v-chip color="white" :text-color="coluna.cor" size="small">
                {{ getTarefasPorStatus(coluna.id).length }}
              </v-chip>
            </div>

            <!-- Cards das Tarefas: eventos no container de conteúdo -->
            <div
              class="column-content"
              @dragover.prevent="handleDragOver(coluna.id)"
              @dragleave="handleDragLeave"
              @drop="handleDrop($event, coluna.id)"
            >
              <div
                v-for="tarefa in getTarefasPorStatus(coluna.id)"
                :key="tarefa.id"
                class="task-card"
                draggable="true"
                @dragstart="handleDragStart($event, tarefa)"
                @dragend="handleDragEnd"
                @click.stop
              >
                <v-card elevation="2" class="mb-3" hover>
                  <v-card-text class="pa-3">
                    <!-- Título da Tarefa -->
                    <div class="d-flex justify-space-between align-start mb-2">
                      <h4 class="task-title">{{ tarefa.title }}</h4>
                      <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                          <v-btn icon variant="text" size="small" v-bind="props">
                            <v-icon size="16">fas fa-ellipsis-v</v-icon>
                          </v-btn>
                        </template>
                        <v-list density="compact">
                          <v-list-item @click="editarTarefa(tarefa)">
                            <v-list-item-title>
                              <v-icon size="16" class="mr-2">fas fa-edit</v-icon>
                              Editar
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="confirmarExclusao(tarefa)">
                            <v-list-item-title class="text-error">
                              <v-icon size="16" class="mr-2">fas fa-trash</v-icon>
                              Excluir
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>

                    <!-- Condomínio -->
                    <div v-if="tarefa.condominium_id" class="mb-2">
                      <v-chip
                        size="small"
                        color="blue-grey"
                        variant="outlined"
                        prepend-icon="fas fa-building"
                      >
                        {{ getCondominioNameById(tarefa.condominium_id) }}
                      </v-chip>
                    </div>

                    <!-- Descrição -->
                    <p class="text-body-2 text-grey-darken-1 mb-3" v-if="tarefa.description">
                      {{ tarefa.description }}
                    </p>

                    <!-- Tags de Prioridade e Data de Vencimento -->
                    <div class="d-flex flex-wrap align-center mb-3" style="gap: 8px">
                      <v-chip
                        size="small"
                        :color="getPrioridadeColor(tarefa.priority)"
                        variant="flat"
                      >
                        {{ tarefa.priority?.toUpperCase?.() || tarefa.priority }}
                      </v-chip>

                      <v-chip
                        size="small"
                        :color="isAtrasada(tarefa) ? 'error' : 'blue-grey'"
                        variant="outlined"
                        prepend-icon="fas fa-calendar"
                        v-if="tarefa.dueDate"
                      >
                        {{ formatarData(tarefa.dueDate) }}
                      </v-chip>
                    </div>

                    <!-- Datas de Criação e Atualização (com fallback createdAt / created_at) -->
                    <div class="mb-3">
                      <div class="d-flex flex-column" style="gap: 4px">
                        <div class="d-flex align-center" style="gap: 8px">
                          <v-icon size="12" color="grey">fas fa-plus-circle</v-icon>
                          <span class="text-caption text-grey">
                            Criado: {{ formatarDataHora(tarefa.created_at || tarefa.createdAt) }}
                          </span>
                        </div>
                        <div class="d-flex align-center" style="gap: 8px" v-if="(tarefa.updated_at || tarefa.updatedAt) && (tarefa.updated_at || tarefa.updatedAt) !== (tarefa.created_at || tarefa.createdAt)">
                          <v-icon size="12" color="grey">fas fa-edit</v-icon>
                          <span class="text-caption text-grey">
                            Atualizado: {{ formatarDataHora(tarefa.updated_at || tarefa.updatedAt) }}
                          </span>
                        </div>
                      </div>
                    </div>

                   <span class="text-caption text-grey">
                      Condomínio: {{ tarefa.condominium_nome || getCondominioNameById(tarefa.condominium) || '—' }}
                    </span>

                    <!-- Avatar do Responsável -->
                    <div class="d-flex justify-space-between align-center mt-3">
                      <div v-if="tarefa.user_id" class="d-flex align-center" style="gap: 8px">
                        <v-avatar size="24" :color="colors.primaryLight">
                          <v-icon color="white" size="14">fas fa-user</v-icon>
                        </v-avatar>
                        <span class="text-caption">{{ getUserNameById(tarefa.user_id) }}</span>
                      </div>
                      <div v-else class="text-caption text-grey">Sem responsável</div>
                      
                      <!-- Indicador de drag -->
                      <v-icon size="16" color="grey-lighten-1" class="drag-handle">
                        fas fa-grip-vertical
                      </v-icon>
                    </div>
                  </v-card-text>
                </v-card>
              </div>

              <!-- Mensagem quando não há tarefas na coluna -->
              <div v-if="getTarefasPorStatus(coluna.id).length === 0" class="empty-column">
                <v-icon size="48" color="grey-lighten-2">{{ coluna.icone }}</v-icon>
                <p class="text-body-2 text-grey mt-2">Nenhuma tarefa</p>
              </div>
            </div>
          </div>
        </div>
      </v-container>

      <!-- Fallback caso não tenha acesso -->
      <div v-else class="d-flex justify-center align-center flex-column" style="height: 100vh;">
        <v-icon size="100" color="error" class="mb-4">fas fa-lock</v-icon>
        <h2 class="mb-2">Acesso Negado</h2>
        <p class="text-grey">Você não tem permissão para acessar esta tela.</p>
        <v-btn :color="colors.primaryLight" @click="router.push('/dashboard')" class="mt-4">
          Voltar ao Dashboard
        </v-btn>
      </div>

      <!-- Dialog Nova/Editar Tarefa -->
      <v-dialog v-model="dialogNovaTarefa" max-width="600px">
        <v-card>
          <v-card-title
            :style="{ backgroundColor: colors.primaryLight }"
            class="text-white"
          >
            <v-icon color="white" class="mr-2">fas fa-{{ editMode ? 'edit' : 'plus' }}</v-icon>
            {{ editMode ? 'Editar Tarefa' : 'Nova Tarefa' }}
          </v-card-title>

          <v-card-text class="pa-6">
            <v-form ref="formNovaTarefa">
              <v-text-field
                v-model="tarefaForm.title"
                label="Título da Tarefa"
                variant="outlined"
                :rules="[(v) => !!v || 'Título é obrigatório']"
                class="mb-4"
              ></v-text-field>

              <v-textarea
                v-model="tarefaForm.description"
                label="Descrição"
                variant="outlined"
                rows="3"
                class="mb-4"
              ></v-textarea>

              <v-row>
                <v-col cols="6">
                  <v-select
                    v-model="tarefaForm.priority"
                    :items="prioridadeOptions"
                    label="Prioridade"
                    variant="outlined"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="tarefaForm.dueDate"
                    label="Data de Vencimento"
                    type="date"
                    variant="outlined"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-select
                v-model="tarefaForm.condominium"
                :items="condominios"
                item-title="nome"
                item-value="nome"
                label="Condomínio"
                placeholder="Escolha um condomínio"
                variant="outlined"
                class="mb-4"
                clearable
              ></v-select>

              <v-select
                v-model="tarefaForm.user_id"
                :items="users"
                item-title="name"
                item-value="id"
                label="Responsável"
                placeholder="Escolha um usuário"
                variant="outlined"
                class="mb-4"
                clearable
              ></v-select>

              <v-select
                v-model="tarefaForm.status"
                :items="statusOptions"
                label="Status"
                variant="outlined"
                class="mb-4"
              ></v-select>
            </v-form>
          </v-card-text>

          <v-card-actions class="pa-6">
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="cancelarEdicao">Cancelar</v-btn>
            <v-btn 
              :color="colors.primaryGreen" 
              @click="salvarTarefa"
              :loading="salvando"
            >
              {{ editMode ? 'Salvar' : 'Criar Tarefa' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog Confirmação de Exclusão -->
      <v-dialog v-model="dialogExclusao" max-width="400px">
        <v-card>
          <v-card-title class="text-h6">Confirmar Exclusão</v-card-title>
          <v-card-text>
            Tem certeza que deseja excluir a tarefa "{{ tarefaExcluir?.title }}"?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="dialogExclusao = false">Cancelar</v-btn>
            <v-btn 
              color="error" 
              @click="excluirTarefa"
              :loading="excluindo"
            >
              Excluir
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Snackbar para notificações -->
      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="3000"
      >
        {{ snackbar.text }}
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import axios from "axios";
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth'
import { menuItems } from '@/constants/MenuItems';

// API Configuration
const API_URL = (process.env.VUE_APP_API_URL || '').replace(/\/$/, '');

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add auth token to requests if available
api.interceptors.request.use(config => {
  // pega token do store se existir, senão do localStorage
  const storeToken = auth?.token || null;
  const storageToken = localStorage.getItem('token');
  const usedToken = storeToken || storageToken;

  if (usedToken) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${usedToken}`,
    };
  }
  return config;
});


// Reactive data
const users = ref([]);
const condominios = ref([]);
const drawer = ref(true);
const filtroTitulo = ref("");
const filtroPrioridade = ref("");
const dialogNovaTarefa = ref(false);
const dialogExclusao = ref(false);
const editMode = ref(false);
const loading = ref(false);
const salvando = ref(false);
const excluindo = ref(false);
const tarefaExcluir = ref(null);
const router = useRouter();
const authStore = useAuthStore();
const auth = useAuthStore();
const token = auth?.token || null;
const isMounted = ref(false);
const userDetails = ref({});

// Controle de acesso
const hasAccess = ref(false);
const checkingAccess = ref(true);

// Snackbar for notifications
const snackbar = ref({
  show: false,
  text: '',
  color: 'success'
});

// Drag & Drop
const draggedTask = ref(null);
const dragOverColumn = ref(null);

// Color scheme
const colors = {
  primaryDark: "#123A5D",
  primaryLight: "#57C2E3",
  primaryGreen: "#A3C940",
  lightBg: "#E7F2F9",
};

// Colunas do Kanban
const colunas = [
  {
    id: "pendente",
    titulo: "Pendente",
    cor: "#FFA726",
    icone: "fas fa-clock",
  },
  {
    id: "em_andamento",
    titulo: "Em Andamento",
    cor: "#42A5F5",
    icone: "fas fa-play-circle",
  },
  {
    id: "revisao",
    titulo: "Em Revisão",
    cor: "#AB47BC",
    icone: "fas fa-eye",
  },
  {
    id: "concluido",
    titulo: "Concluída",
    cor: "#66BB6A",
    icone: "fas fa-check-circle",
  },
];

// Options para filtros
const statusOptions = [
  { title: "Pendente", value: "pendente" },
  { title: "Em Andamento", value: "em_andamento" },
  { title: "Em Revisão", value: "revisao" },
  { title: "Concluída", value: "concluida" },
];

const prioridadeOptions = [
  { title: "Baixa", value: "baixa" },
  { title: "Média", value: "media" },
  { title: "Alta", value: "alta" },
  { title: "Urgente", value: "urgente" },
];

// Form data
const tarefaForm = ref({
  title: "",
  description: "",
  priority: "media",
  dueDate: "",
  status: "pendente",
  user_id: null,
  condominium: null,
});
// Helper: normaliza status (remove acentos e torna lowercase)
const normalizeStatus = (s) => {
  if (s === null || s === undefined) return s;
  return String(s)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
};

// Função para verificar acesso à tela calendar
const checkCalendarAccess = (userDetails) => {
  if (!userDetails || !userDetails.allowedScreens) {
    return false;
  }
  
  return userDetails.allowedScreens.includes('calendar');
};

// Carregar condominios
const carregarCondominios = async () => {
  try {
    const response = await api.get('/condominium/all');
    condominios.value = response.data.map(cond => ({
      id: cond.id,
      nome: cond.nome || cond.name,
      name: cond.name || cond.nome
    }));
  } catch (error) {
    console.error('Erro ao carregar condominios:', error);
    showNotification('Erro ao carregar lista de condomínios', 'error');
  }
};

// Dados das tarefas
const tarefas = ref([]);

// API Functions
const carregarTarefas = async () => {
  loading.value = true;
  try {
    const response = await api.get('/kanban');
    const raw = response.data || [];

    tarefas.value = raw.map(t => {
      // normaliza status
      const normalizedStatus = normalizeStatus(t.status);

      // tenta descobrir o nome do condomínio vindo da API
      let condNome =
        t.condominium_nome ||
        t.condominiumName || // variações
        t.condominium_name ||
        t.nome ||
        t.name ||
        (t.condominium && typeof t.condominium === 'string' && isNaN(Number(t.condominium)) ? t.condominium : undefined);

      // se ainda não temos e t.condominium é um id, procura na lista local de condomínios
      if (!condNome && t.condominium) {
        const found = condominios.value.find(c => String(c.id) === String(t.condominium));
        if (found) condNome = found.nome || found.name;
      }

      return {
        ...t,
        status: normalizedStatus,
        condominium_nome: condNome || null
      };
    });

    showNotification('Tarefas carregadas com sucesso', 'success');
  } catch (error) {
    console.error('Erro ao carregar tarefas:', error);
    showNotification('Erro ao carregar tarefas', 'error');
  } finally {
    loading.value = false;
  }
};

const criarTarefa = async (dados) => {
  try {
    const payload = { ...dados, status: normalizeStatus(dados.status) };
    const response = await api.post('/kanban', payload);
    // normaliza antes de push
    tarefas.value.push({ ...response.data, status: normalizeStatus(response.data.status) });
    showNotification('Tarefa criada com sucesso', 'success');
    return response.data;
  } catch (error) {
    console.error('Erro ao criar tarefa:', error);
    showNotification('Erro ao criar tarefa', 'error');
    throw error;
  }
};

const atualizarTarefa = async (id, dados) => {
  try {
    const payload = { ...dados, status: normalizeStatus(dados.status) };
    const response = await api.put(`/kanban/${id}`, payload);
    const index = tarefas.value.findIndex(t => String(t.id) === String(id));
    if (index !== -1) {
      tarefas.value[index] = { ...response.data, status: normalizeStatus(response.data.status) };
    }
    showNotification('Tarefa atualizada com sucesso', 'success');
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar tarefa:', error);
    showNotification('Erro ao atualizar tarefa', 'error');
    throw error;
  }
};

const deletarTarefa = async (id) => {
  try {
    await api.delete(`/kanban/${id}`);
    const index = tarefas.value.findIndex(t => String(t.id) === String(id));
    if (index !== -1) {
      tarefas.value.splice(index, 1);
    }
    showNotification('Tarefa excluída com sucesso', 'success');
  } catch (error) {
    console.error('Erro ao excluir tarefa:', error);
    showNotification('Erro ao excluir tarefa', 'error');
    throw error;
  }
};

// Helper function to show notifications
const showNotification = (text, color = 'success') => {
  snackbar.value = {
    show: true,
    text,
    color
  };
};

// Computed properties
const tarefasFiltradas = computed(() => {
  return tarefas.value.filter((tarefa) => {
    const matchTitulo =
      !filtroTitulo.value ||
      (tarefa.title && tarefa.title.toLowerCase().includes(filtroTitulo.value.toLowerCase())) ||
      (tarefa.description && tarefa.description.toLowerCase().includes(filtroTitulo.value.toLowerCase()));

    const matchPrioridade =
      !filtroPrioridade.value || tarefa.priority === filtroPrioridade.value;

    return matchTitulo && matchPrioridade;
  });
});

const tarefasConcluidas = computed(() => {
  return tarefas.value.filter((tarefa) => normalizeStatus(tarefa.status) === 'concluido');
});

const tarefasPendentes = computed(() => {
  return tarefas.value.filter((tarefa) => normalizeStatus(tarefa.status) === 'pendente');
});

const tarefasAtrasadas = computed(() => {
  const hoje = new Date();
  return tarefas.value.filter((tarefa) => {
    if (!tarefa.dueDate) return false;
    const dataVencimento = new Date(tarefa.dueDate);
    return normalizeStatus(tarefa.status) !== "concluida" && dataVencimento < hoje;
  });
});

const getTarefasPorStatus = (status) => {
  const norm = normalizeStatus(status);
  return tarefasFiltradas.value.filter((tarefa) => normalizeStatus(tarefa.status) === norm);
};

const getPrioridadeColor = (prioridade) => {
  const colors = {
    baixa: "green",
    media: "blue",
    alta: "orange",
    urgente: "red",
  };
  return colors[prioridade] || "grey";
};

const formatarData = (data) => {
  if (!data) return '';
  return new Date(data).toLocaleDateString("pt-BR");
};

const formatarDataHora = (data) => {
  if (!data) return '';
  return new Date(data).toLocaleString("pt-BR", {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const isAtrasada = (tarefa) => {
  if (!tarefa.dueDate) return false;
  const hoje = new Date();
  const dataVencimento = new Date(tarefa.dueDate);
  return normalizeStatus(tarefa.status) !== "concluida" && dataVencimento < hoje;
};

const limparFiltros = () => {
  filtroTitulo.value = "";
  filtroPrioridade.value = "";
};

// Drag & Drop Methods (mais robustos)
const handleDragStart = (event, tarefa) => {
  draggedTask.value = tarefa;
  event.dataTransfer.effectAllowed = "move";
  try {
    event.dataTransfer.setData('text/plain', String(tarefa.id));
    event.dataTransfer.setData('application/json', JSON.stringify(tarefa));
  } catch (e) {
    // some browsers might throw; ignore
  }
  if (event.target) event.target.style.opacity = "0.5";
};

const handleDragEnd = (event) => {
  if (event.target) event.target.style.opacity = "1";
  draggedTask.value = null;
  dragOverColumn.value = null;
};

const handleDragOver = (columnId) => {
  dragOverColumn.value = columnId;
};

const handleDragLeave = () => {
  dragOverColumn.value = null;
};

const handleDrop = async (event, newStatus) => {
  event.preventDefault();
  dragOverColumn.value = null;

  // fallback: recuperar dados do dataTransfer se draggedTask estiver vazio
  if (!draggedTask.value) {
    try {
      const data = event.dataTransfer.getData('application/json');
      if (data) draggedTask.value = JSON.parse(data);
      else {
        const id = event.dataTransfer.getData('text/plain');
        if (id) draggedTask.value = tarefas.value.find(t => String(t.id) === String(id));
      }
    } catch (e) {
      console.warn('Não foi possível recuperar tarefa do dataTransfer', e);
    }
  }

  if (draggedTask.value && normalizeStatus(draggedTask.value.status) !== normalizeStatus(newStatus)) {
    try {
      await atualizarTarefa(draggedTask.value.id, {
        ...draggedTask.value,
        status: normalizeStatus(newStatus)
      });
    } catch (error) {
      // Recarrega em caso de erro
      await carregarTarefas();
    }
  }
};

// CRUD Operations
const salvarTarefa = async () => {
  if (!tarefaForm.value.title) {
    showNotification('Título é obrigatório', 'error');
    return;
  }

  salvando.value = true;
  try {
    const storedUserId = localStorage.getItem('user_id') || userDetails.value?.id;
    const userId = tarefaForm.value.user_id || storedUserId || 1;

   const dadosTarefa = {
  ...tarefaForm.value,
  user_id: Number(userId),
  condominium: tarefaForm.value.condominium || null,
  status: normalizeStatus(tarefaForm.value.status)
};

    if (editMode.value && tarefaForm.value.id) {
      await atualizarTarefa(tarefaForm.value.id, dadosTarefa);
    } else {
      await criarTarefa(dadosTarefa);
    }

    dialogNovaTarefa.value = false;
    resetForm();
  } catch (error) {
    console.error('Erro ao salvar tarefa:', error);
  } finally {
    salvando.value = false;
  }
};

const editarTarefa = (tarefa) => {
  tarefaForm.value = { ...tarefa };
  editMode.value = true;
  dialogNovaTarefa.value = true;
};

const confirmarExclusao = (tarefa) => {
  tarefaExcluir.value = tarefa;
  dialogExclusao.value = true;
};

const excluirTarefa = async () => {
  if (!tarefaExcluir.value) return;

  excluindo.value = true;
  try {
    await deletarTarefa(tarefaExcluir.value.id);
    dialogExclusao.value = false;
    tarefaExcluir.value = null;
  } catch (error) {
    console.error('Erro ao excluir tarefa:', error);
  } finally {
    excluindo.value = false;
  }
};

const cancelarEdicao = () => {
  dialogNovaTarefa.value = false;
  resetForm();
};

const resetForm = () => {
  tarefaForm.value = {
    title: "",
    description: "",
    priority: "media",
    dueDate: "",
    status: "pendente",
    user_id: null,
    condominium: null,
  };
  editMode.value = false;
};

const logout = () => {
  if (authStore && typeof authStore.logout === 'function') {
    authStore.logout();
  }
  if (router && typeof router.push === 'function') {
    router.push('/');
  }
};

// Load user details from storage or API
const fetchUserDetails = async () => {
  if (!isMounted.value || !token) {
    checkingAccess.value = false;
    return;
  }

  try {
    const response = await axios.get(`${API_URL}/me`, { 
      headers: { Authorization: `Bearer ${token}` } 
    });

    if (isMounted.value && response.data) {
      userDetails.value = response.data;
      
      // Verifica se o usuário tem acesso à tela calendar
      hasAccess.value = checkCalendarAccess(response.data);
      
      // Se não tem acesso, redireciona para access denied
      if (!hasAccess.value) {
        router.push('/access-denied');
        return;
      }
    }
  } catch (error) {
    console.error('Erro ao carregar dados do usuário:', error);
    if (isMounted.value) {
      userDetails.value = null;
      hasAccess.value = false;
      // Em caso de erro na API, redireciona para access denied
      router.push('/access-denied');
    }
  } finally {
    checkingAccess.value = false;
  }
};

// Watcher para reagir a mudanças nos userDetails
watch(userDetails, (newUserDetails) => {
  if (newUserDetails) {
    hasAccess.value = checkCalendarAccess(newUserDetails);
    if (!hasAccess.value) {
      router.push('/access-denied');
    }
  }
}, { deep: true });

// utility to get user name
const getUserNameById = (id) => {
  const u = users.value.find(x => x.id === id);
  return u ? u.name : '—';
};

// condomínio name
const getCondominioNameById = (idOrName) => {
  if (!idOrName) return '—';

  // se já veio o nome
  if (typeof idOrName === 'string' && isNaN(Number(idOrName))) {
    return idOrName;
  }

  // tenta encontrar por id
  const byId = condominios.value.find(x => String(x.id) === String(idOrName));
  if (byId) return byId.nome || byId.name;

  // tenta encontrar por nome (caso o idOrName seja nome)
  const byName = condominios.value.find(x => (x.nome && x.nome === idOrName) || (x.name && x.name === idOrName));
  if (byName) return byName.nome || byName.name;

  // fallback: retorna string
  return String(idOrName);
};

// carregar usuarios
const carregarUsuarios = async () => {
  try {
    const resp = await api.get('/all-users');
    users.value = (resp.data || []).map(u => ({ id: u.id, name: u.name }));
  } catch (error) {
    console.error('Erro ao carregar usuários:', error);
    showNotification('Erro ao carregar lista de usuários', 'error');
  }
};

// Lifecycle
onMounted(async() => {
  isMounted.value = true;
  
  // Primeiro verifica o acesso do usuário
  await fetchUserDetails();
  
  // Se não tem acesso, para por aqui
  if (!hasAccess.value) {
    return;
  }
  
  // Se tem acesso, carrega o resto dos dados
  await carregarCondominios();
  await carregarTarefas();
  await carregarUsuarios();
});

// Expor variáveis para uso no template
// eslint-disable-next-line no-undef
defineExpose({
  hasAccess,
  checkingAccess,
  userDetails
});
</script>

<style scoped>
/* Kanban Board Layout */
.kanban-board {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding-left: 20px;
  min-height: 600px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  background: white;
}

.kanban-column {
  min-width: 340px;
  background: #fafafa;
  border-radius: 12px;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  max-width: 380px;
}

.kanban-column.drag-over {
  border-color: #57c2e3;
  background: #f0f9ff;
  transform: translateY(-2px);
}

.column-header {
  padding: 12px;
  border-radius: 12px 12px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.column-content {
  padding: 8px 12px 16px;
  min-height: 360px;
  flex: 1 1 auto;
  overflow-y: auto;
}

/* Task Card Styling */
.task-card {
  cursor: grab;
  transition: all 0.3s ease;
}

.task-card:active {
  cursor: grabbing;
}

.task-card:hover {
  transform: translateY(-2px);
}

.task-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0;
  color: #2c3e50;
}

.empty-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  text-align: center;
  opacity: 0.6;
}

/* Custom scrollbar for kanban board */
.kanban-board::-webkit-scrollbar {
  height: 8px;
}

.kanban-board::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.kanban-board::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.kanban-board::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Card hover effects */
.v-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .kanban-column {
    min-width: 260px;
  }

  .kanban-board {
    gap: 12px;
  }
}

/* Animation for drag effects */
.task-card {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.task-card:hover:not(:active) {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Additional custom styles */
.lowercase {
  text-transform: lowercase;
}

.pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.gradient-text {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.menu-item {
  margin: 4px 8px;
  transition: all 0.3s ease;
}

.menu-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.active-item {
  background-color: rgba(87, 194, 227, 0.2) !important;
  border-left: 3px solid #57C2E3;
}

.logout-btn {
  transition: all 0.3s ease;
}

.logout-btn:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Melhorias visuais para as datas */
.text-caption {
  font-size: 11px !important;
}

/* Chip de condomínio */
.v-chip--variant-outlined {
  border-width: 1px;
}
</style>
